import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check, ArrowRight } from "lucide-react";
import logo from "@/assets/logo.png";
import PageSEO from "@/components/PageSEO";

const VIPUpgrade = () => {
  const vipBenefits = [
    "Full replay access to all live sessions",
    "VIP Day 4 live build session",
    "Build your own real estate lead generation product",
    "Done-for-you versions of everything built live",
    "Tools you can customize for your market and business",
  ];

  const handleVIPUpgrade = () => {
    window.open("https://buy.stripe.com/dRm9ATdsrbWMd6jev45c400", "_blank");
  };

  return (
    <div className="min-h-screen bg-[hsl(220,20%,12%)]">
      <PageSEO
        title="VIP Upgrade | Marquetta Bryant"
        description="Upgrade to VIP for full replay access and the live build session."
        canonical="https://marquettabryant.com/vip-upgrade"
        noindex
      />
      {/* Minimal Header */}
      <header className="py-6 border-b border-white/10">
        <div className="container mx-auto px-4">
          <Link to="/">
            <img src={logo} alt="Marquetta" className="h-10 mx-auto" />
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 md:py-20">
        <div className="max-w-2xl mx-auto">
          {/* Headline Section */}
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
              Before You Continue…
            </h1>
            <p className="text-white/80 text-lg max-w-xl mx-auto">
              If you want to stop paying for real estate tools you do not own, this is where that happens.
            </p>
            <p className="text-white/60 text-base mt-4 max-w-lg mx-auto">
              Supporter access gives you live participation.
              <br />
              VIP gives you ownership, replays, and assets you can deploy.
            </p>
          </div>

          {/* Upsell Section */}
          <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 md:p-10 border border-white/10">
            <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8">
              Upgrade to VIP Builder Access
            </h2>

            {/* VIP Product Card */}
            <div className="bg-gradient-to-br from-primary/20 to-accent/10 rounded-2xl p-6 md:p-8 border border-primary/30 mb-8">
              <h3 className="text-xl font-bold text-white mb-6 text-center">
                VIP Builder Access Includes
              </h3>
              <ul className="space-y-4 mb-6">
                {vipBenefits.map((benefit, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
                      <Check className="w-4 h-4 text-primary" />
                    </div>
                    <span className="text-white/90">{benefit}</span>
                  </li>
                ))}
              </ul>
              <p className="text-white/60 text-sm text-center mb-4">
                VIP is designed for real estate professionals who want to replace paid tools with assets they control.
              </p>
              <div className="text-center">
                <span className="text-3xl font-bold text-white">$97</span>
                <span className="text-white/50 ml-2">one-time investment</span>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="space-y-4">
              <Button 
                size="lg" 
                variant="premium" 
                className="w-full group text-lg py-6"
                onClick={handleVIPUpgrade}
              >
                Upgrade to VIP Builder Access
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <p className="text-white/40 text-sm text-center">
                Includes replays, VIP Day 4, and done-for-you assets
              </p>
              <a 
                href="https://donate.stripe.com/14A28q1Fjaa44G73ek8k800" 
                target="_blank"
                rel="noopener noreferrer"
                className="block text-center text-white/50 hover:text-white/70 transition-colors text-base py-4 underline underline-offset-4"
              >
                I will continue with live access only.
              </a>
            </div>

            {/* Trust Line */}
            <p className="text-white/50 text-sm text-center mt-8 italic">
              VIP is where you stop learning about tools and start owning them.
            </p>
          </div>
        </div>
      </main>

      {/* Minimal Footer */}
      <footer className="py-6 border-t border-white/10 mt-12">
        <div className="container mx-auto px-4 text-center">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Marquetta Bryant. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default VIPUpgrade;
